import "@/App.css";
import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

// Public
import PublicLayout from "@/components/public/PublicLayout";
import Home from "@/pages/Home";
import HoodiWard29 from "@/pages/HoodiWard29";
import About from "@/pages/About";
import SocialWork from "@/pages/SocialWork";
import SocialWorkDetail from "@/pages/SocialWorkDetail";
import CharitableTrust from "@/pages/CharitableTrust";
import Awards from "@/pages/Awards";
import LeadershipRoles from "@/pages/LeadershipRoles";
import GbaVision from "@/pages/GbaVision";
import SubmitWardIssue from "@/pages/SubmitWardIssue";
import MediaPress from "@/pages/MediaPress";
import Gallery from "@/pages/Gallery";
import Facts from "@/pages/Facts";
import Contact from "@/pages/Contact";
import TrackIssue from "@/pages/TrackIssue";
import DigitalCard from "@/pages/DigitalCard";
import Biography from "@/pages/Biography";

// Admin
import AdminLayout from "@/admin/AdminLayout";
import AdminLogin from "@/admin/AdminLogin";
import AdminDashboard from "@/admin/AdminDashboard";
import ResourceManager from "@/admin/ResourceManager";
import WardIssuesAdmin from "@/admin/WardIssuesAdmin";
import SubmissionsAdmin from "@/admin/SubmissionsAdmin";
import SettingsEditor from "@/admin/SettingsEditor";
import TrustEditor from "@/admin/TrustEditor";
import DigitalCardEditor from "@/admin/DigitalCardEditor";
import BiographyEditor from "@/admin/BiographyEditor";

function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center bg-navy"><Loader2 className="h-8 w-8 animate-spin text-gold" /></div>;
  if (!user) return <Navigate to="/admin/login" replace />;
  return children;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          {/* Public */}
          <Route element={<PublicLayout />}>
            <Route path="/" element={<Home />} />
            <Route path="/hoodi-ward-29" element={<HoodiWard29 />} />
            <Route path="/about-girish-kumar-naidu" element={<About />} />
            <Route path="/social-work" element={<SocialWork />} />
            <Route path="/social-work/:slug" element={<SocialWorkDetail />} />
            <Route path="/charitable-trust" element={<CharitableTrust />} />
            <Route path="/awards-recognition" element={<Awards />} />
            <Route path="/leadership-roles" element={<LeadershipRoles />} />
            <Route path="/gba-corporator-vision" element={<GbaVision />} />
            <Route path="/submit-ward-issue" element={<SubmitWardIssue />} />
            <Route path="/track-issue" element={<TrackIssue />} />
            <Route path="/digital-card" element={<DigitalCard />} />
            <Route path="/biography" element={<Biography />} />
            <Route path="/media-press" element={<MediaPress />} />
            <Route path="/gallery" element={<Gallery />} />
            <Route path="/facts-about-girish-kumar-naidu" element={<Facts />} />
            <Route path="/contact" element={<Contact />} />
          </Route>

          {/* Admin */}
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<ProtectedRoute><AdminLayout /></ProtectedRoute>}>
            <Route index element={<AdminDashboard />} />
            <Route path="ward-issues" element={<WardIssuesAdmin />} />
            <Route path="submissions" element={<SubmissionsAdmin />} />
            <Route path="settings" element={<SettingsEditor />} />
            <Route path="digital-card" element={<DigitalCardEditor />} />
            <Route path="biography" element={<BiographyEditor />} />
            <Route path="trust" element={<TrustEditor />} />
            <Route path="resource/:resource" element={<ResourceManager />} />
          </Route>

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
